export const ADSENSE_CLIENT = 'ca-pub-5620005037726316'
export const ADSENSE_SCRIPT_SRC = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=' + ADSENSE_CLIENT
export const ADSENSE_POPUP_WAIT_MS = 15000
export const ADSENSE_STRIP_WAIT_MS = 5000

export function isAdsenseBanner (banner) {
  if (!banner) {
    return false
  }
  return banner.kind === 'adsense' || /adsbygoogle/i.test(banner.html || '')
}

export function adsenseHasVisibleCreative (ins) {
  if (!ins) {
    return false
  }
  const status = ins.getAttribute('data-ad-status')
  if (status === 'unfilled') {
    return false
  }
  if (status === 'filled') {
    return true
  }
  const iframe = ins.querySelector('iframe')
  if (!iframe) {
    return false
  }
  const rect = iframe.getBoundingClientRect()
  return rect.height > 40 && rect.width > 40
}

export function reviveScripts (root) {
  if (!root) {
    return
  }
  Array.from(root.querySelectorAll('script')).forEach((old) => {
    const next = document.createElement('script')
    Array.from(old.attributes).forEach((attr) => next.setAttribute(attr.name, attr.value))
    next.textContent = old.textContent
    if (old.parentNode) {
      old.parentNode.replaceChild(next, old)
    }
  })
}

export function ensureAdsenseReady () {
  if (window.adsbygoogle && typeof window.adsbygoogle.push === 'function') {
    return Promise.resolve()
  }
  return new Promise((resolve) => {
    const existing = document.querySelector('script[src*="adsbygoogle.js"]')
    if (existing) {
      existing.addEventListener('load', () => resolve(), { once: true })
      existing.addEventListener('error', () => resolve(), { once: true })
      return
    }
    const script = document.createElement('script')
    script.async = true
    script.src = ADSENSE_SCRIPT_SRC
    script.crossOrigin = 'anonymous'
    script.onload = () => resolve()
    script.onerror = () => resolve()
    document.head.appendChild(script)
  })
}

export function requestAdsenseFill (root) {
  const ins = root && root.querySelector('ins.adsbygoogle')
  if (!ins || ins.getAttribute('data-pw-adsense-requested') === '1') {
    return ins
  }
  ins.setAttribute('data-pw-adsense-requested', '1')
  reviveScripts(root)
  return ins
}
